<template>
    <div class="home">
        <admin />
    </div>
</template>

<script>
    import Admin from "../components/views/Admin";
    export default {
        name: "AdminView",
        components: {Admin}
    }
</script>

<style scoped>

</style>
